// extracted by mini-css-extract-plugin
export var card = "StaffCard-module--card--8y4sm";
export var cardImage = "StaffCard-module--card-image--2nRb7";
export var main = "StaffCard-module--main--2MvVt";
export var hoverIt = "StaffCard-module--hoverIt--XaMHw";
export var cardTitle = "StaffCard-module--card-title--3I2kZ";
export var spinAround = "StaffCard-module--spinAround--2wN6o";